import type { TableMergedState } from 'components/Table/model/TableModel';

export const selectTableHasRowSelection = (s: TableMergedState): boolean =>
  !!(s.bulkActions && s.rowIdField);
